import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  styled,
} from "@mui/material";
import { NumericFormat, PatternFormat } from "react-number-format";
import { branches } from "../branches";
import DatePicker, { registerLocale } from "react-datepicker";
import { ru } from "date-fns/locale";
registerLocale("ru", ru);

import "react-datepicker/dist/react-datepicker.css";
import styles from "../borrower.module.css";
import { useState } from "react";
import { validateKazakhPhone } from "@/utils/phoneValidation";

const StyledTextField = styled(TextField)(
  ({ theme }) => `
   
    & .MuiInput-underline:after {
      border-bottom-color: white;
      background: white;
      outline:none;
    }
    & .MuiFilledInput-root {
      background: #F3F3F7;
      border-radius:12px;
      outline:none;
      
      &:before {
        border: none;
        outline:none;
        &:hover {
          border: none;
        }
      };
      &:after {
        border:none;
        outline:none;
      }
     
    }
   & .MuiFilledInput-input:-webkit-autofill {
    border-radius:12px;
   }
  
   & .MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before {
    border-bottom: none;
      }
     
  `
);

const StyledGrid = styled(Grid)(
  ({ theme }) => `
    &.MuiGrid-item {
      padding-top: 0;
    }
    & .react-datepicker-wrapper {
      width: 100%;
    }
    `
);

const StyledSelect = styled(Select)(
  ({ theme }) => ` 
    &.MuiFilledInput-root {
      background: #F3F3F7;
      border-radius:12px;
      outline:none;
      
      &:before {
        border: none;
        outline:none;
        &:hover {
          border: none;
        }
      };
      &:after {
        border:none;
        outline:none;
      }
     
    }
    
    &.MuiFilledInput-input:-webkit-autofill {
      border-radius:12px;
     }
    
     &.MuiFilledInput-root:hover:not(.Mui-disabled, .Mui-error):before {
      border-bottom: none;
        }   
        `
);

interface StyledLabelType {
  isBranch: string;
}

const StyledLabel = styled(InputLabel, {
  shouldForwardProp: (propName) => {
    return propName !== "isBranch";
  },
})(({ isBranch }: StyledLabelType) => ({
  "&.MuiInputLabel-root": {
    top: isBranch ? "14px" : "0px",
  },
  "&.Mui-focused": {
    top: "14px",
  },
}));

const Form = ({
  iin,
  setIin,
  iinErr,
  phone,
  setPhone,
  phoneErr,
  email,
  setError,
  isValidEmail,
  setEmail,
  startDate,
  setStartDate,
  dateErr,
  branch,
  setBranch,
  branchErr,
  error,
  setIInErr,
  setPhoneErr,
  setDateErr,
  setBranchErr,
}) => {
  const [phoneFocused, setPhoneFocused] = useState(false);
  return (
    <Box sx={{ width: "100%" }}>
      <Grid
        container
        spacing={2}
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
        })}
      >
        <Grid item sx={{ width: "100%" }}>
          <NumericFormat
            customInput={StyledTextField}
            id="iinForm"
            label="ИИН"
            inputProps={{ maxLength: "12" }}
            variant="filled"
            allowLeadingZeros
            value={iin}
            onValueChange={({ value }) => {
              const isFullIIN = value.length === 12;
              if (isFullIIN) {
                setIInErr(false);
              }
              setIin(value);
            }}
            sx={(theme) => ({
              width: "100%",
              "& fieldset": { border: "none" },
              borderRadius: "12px",
              border: iinErr ? "1px solid red" : "none",
              [theme.breakpoints.down("sm")]: { width: "100%" },
            })}
          />
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <PatternFormat
            customInput={StyledTextField}
            allowEmptyFormatting={phoneFocused}
            format="+7 (###) ###-##-##"
            mask="_"
            id="phoneForm"
            label="Номер телефона"
            variant="filled"
            type="tel"
            value={phone}
            onValueChange={({ value }) => {
              const phoneValidation = validateKazakhPhone(value);
              if (phoneValidation.isValid) {
                setPhoneErr(false);
              }
              setPhone(value);
            }}
            onFocus={() => setPhoneFocused(true)}
            onBlur={() => setPhoneFocused(false)}
            sx={(theme) => ({
              borderRadius: "12px",
              width: "100%",
              minWidth: "100%",
              maxWidth: "100%",
              border: phoneErr ? "1px solid red" : "none",
              [theme.breakpoints.down("sm")]: { width: "100%" },
            })}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={(theme) => ({
          marginTop: "10px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
          },
        })}
      >
        <StyledGrid item sx={{ width: "100%" }}>
          <StyledTextField
            id="emailForm"
            label="Электронная почта"
            // error={!!error}
            // helperText={"Email is invalid"}
            variant="filled"
            value={email}
            type="email"
            onChange={(e) => {
              if (isValidEmail(e.target.value)) {
                setError(false);
              }

              setEmail(e.target.value);
            }}
            sx={(theme) => ({
              borderRadius: "12px",
              width: "100%",
              border: error ? "1px solid red" : "none",
              [theme.breakpoints.down("sm")]: { width: "100%" },
            })}
          />
        </StyledGrid>
        {/* <StyledGrid item sx={{ width: "100%" }}>
          <DatePicker
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
              if (date) {
                setDateErr(false);
              }
            }}
            dateFormat="dd/MM/yyyy"
            placeholderText="Дата регистрации ИП"
            locale={ru}
            className={dateErr ? styles.datePickerTwo : styles.datePicker}
          />
        </StyledGrid> */}
        <StyledGrid item sx={{ width: "100%" }}>
          <FormControl
            sx={(theme) => ({
              minWidth: "100%",
              borderRadius: "12px",
              border: branchErr ? "1px solid red" : "none",
              [theme.breakpoints.down("md")]: {
                width: "100%",
                marginTop: "16px",
              },
            })}
          >
            <StyledLabel isBranch={`${branch}`}>Город обслуживания</StyledLabel>
            <StyledSelect
              value={branch}
              variant="filled"
              onChange={(event) => {
                setBranch(event.target.value as string);
                if (event.target.value) {
                  setBranchErr(false);
                }
              }}
              fullWidth
              label="Город обслуживания"
            >
              {branches
                .sort((a, b) => a.order - b.order)
                .map(({ name, dep_code }) => {
                  return (
                    <MenuItem key={dep_code} value={dep_code}>
                      {name}
                    </MenuItem>
                  );
                })}
            </StyledSelect>
          </FormControl>
        </StyledGrid>
      </Grid>
    </Box>
  );
};

export default Form;
